"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 7.999a7.996 7.996 0 1 1 15.993 0c0 3.922-2.827 7.178-6.553 7.859v-1.015c3.167-.667 5.553-3.482 5.553-6.844a7.005 7.005 0 0 0-6.997-6.997C4.138 1.002 1 4.141 1 7.999a7.004 7.004 0 0 0 6.996 6.996c.166 0 .33-.012.492-.024l.034-.003v1l-.086.006c-.145.01-.291.021-.44.021A7.996 7.996 0 0 1 0 7.999Zm8.554-.455h3.08v1h-3.08v3.09h-1v-3.09H4.36v-1h3.195V4.36h1v3.184Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 12C0 5.373 5.372 0 12 0c6.627 0 12 5.373 12 12 0 5.887-4.242 10.773-9.833 11.794v-1.137c4.961-1.008 8.708-5.402 8.708-10.657 0-5.996-4.879-10.875-10.875-10.875C6.003 1.125 1.125 6.004 1.125 12c0 5.997 4.878 10.875 10.875 10.875.24 0 .478-.017.715-.034l.075-.006v1.125l-.15.01c-.212.015-.424.03-.64.03-6.628 0-12-5.373-12-12Zm12.65.631v4.826h-1.125v-4.826H6.542v-1.125h4.983V6.54h1.125v4.966h4.808v1.125H12.65Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 16C0 7.164 7.163 0 16 0c8.836 0 16 7.164 16 16 0 7.849-5.656 14.364-13.111 15.726v-1.517C25.504 28.866 30.5 23.006 30.5 16c0-7.995-6.505-14.5-14.5-14.5C8.004 1.5 1.5 8.005 1.5 16c0 7.996 6.504 14.5 14.5 14.5.321 0 .637-.023.953-.046l.1-.007v1.5l-.199.014c-.283.02-.566.039-.854.039-8.837 0-16-7.164-16-16Zm16.867.841v6.435h-1.5v-6.435H8.723v-1.5h6.644v-6.62h1.5v6.62h6.41v1.5h-6.41Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24c0 11.774-8.482 21.562-19.666 23.602v-1.906c10.131-2.02 17.79-10.98 17.79-21.696C46.125 11.8 36.2 1.875 24 1.875S1.875 11.8 1.875 24 11.8 46.125 24 46.125c.531 0 1.057-.026 1.579-.062v1.88A25.02 25.02 0 0 1 24 48C10.745 48 0 37.255 0 24Zm25.112 1.074v9.84h-1.875v-9.84H13.083V23.2h10.154V13.081h1.875v10.118h9.804v1.875h-9.804Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 32C0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 15.699-11.309 28.749-26.222 31.47v-2.542C51.287 58.234 61.5 46.289 61.5 32 61.5 15.734 48.266 2.5 32 2.5 15.733 2.5 2.5 15.734 2.5 32c0 16.267 13.233 29.5 29.5 29.5.708 0 1.409-.034 2.105-.083v2.506c-.696.046-1.397.077-2.105.077C14.327 64 0 49.673 0 32Zm33.483 1.432v13.12h-2.5v-13.12H17.444v-2.5h13.54v-13.49h2.5v13.49h13.071v2.5H33.483Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconAddItemBreak = function IconAddItemBreak(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Add Item Break' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "AddItemBreak"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconAddItemBreak.sizes = [16, 24, 32, 48, 64];
IconAddItemBreak.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconAddItemBreak;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/other/AddItemBreak.js
// module id = 2183
// module chunks = 0